import { styled } from '@mui/system';
import DialogContent from '@mui/material/DialogContent';

import inlineStyles from './styles';
import { interactionStrokeSubtle, textPrimary1, white } from '../../../colors';

export const StyledDialogContent = styled(DialogContent)({
	...inlineStyles.dialogContent,
});

export const StyledDatePickerField = styled('div')(({ theme }) => ({
	'& label': {
		display: 'block',
	},
	'& .MuiFormControl-root.MuiTextField-root': {
		marginTop: '0 !important',
	},
	'& .MuiOutlinedInput-root': {
		minHeight: 40,
		borderRadius: 4,
		backgroundColor: white,
		[theme.breakpoints.down('sm')]: {
			minHeight: 56,
		},
	},
	'& .MuiOutlinedInput-input': {
		padding: '0 0 0 16px',
		color: textPrimary1,
		fontSize: 13,
		fontWeight: 600,
		lineHeight: '19px',
		[theme.breakpoints.down('sm')]: {
			fontSize: 16,
			lineHeight: '25px',
		},
	},

	'&.is-empty .MuiOutlinedInput-input': {
		fontWeight: 300,
	},
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: interactionStrokeSubtle,
	},
	'& .MuiIconButton-root': {
		backgroundColor: 'transparent',
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	'& .MuiTouchRipple-root': {
		display: 'none',
	},
}));
